import { useState } from "react";
import trackingEventDictionary from "../../../src/core/dictionary/tracking-event";
import AddFavModal from "../AddFavModal";
import { profileType } from "@utils/enum";
import Button from "@components/base/button";

const AddToFavourite = ({ prospectData, type, tradeDirection, country, dataSource, analyticsCountryID, pathname, currentUserPlan, disabled, triggerPendo, isRedirect }) => {
  const [showFavModal, setFavModal] = useState(false);

  const handleClose = () => {
    setFavModal(false);
  };

  return (
    <div>
      <Button
        variant="secondaryWithIcon"
        size="small"
        className="tw-h-8 tw-font-semibold tw-text-xs tw-flex tw-items-center disabled:tw-cursor-not-allowed"
        disabled={disabled}
        onClick={(e) => {
          e.stopPropagation();
          if (type.toLowerCase() === "importer") {
            triggerPendo(trackingEventDictionary.uniqueImportersTabSelectionStripAddToFavourites);
          } else if (type.toLowerCase() === "exporter") {
            triggerPendo(trackingEventDictionary.uniqueExportersTabSelectionStripAddToFavourites);
          }
          if (type.toLowerCase() === "logistics") {
            triggerPendo(trackingEventDictionary.uniqueLogisticsTabSelectionStripAddToFavourites);
          }
          setFavModal(true);
        }}>
        <span className="material-symbols-outlined tw-w-5">star</span>
        Bookmark
      </Button>

      {showFavModal ? <AddFavModal profileType={type.toLowerCase() === "logistics" ? profileType.logistics : profileType.company} show={showFavModal} handleClose={handleClose} prospectData={prospectData} type={type} tradeDirection={tradeDirection} country={country} dataSource={dataSource} analyticsCountryID={analyticsCountryID} pathname={pathname} currentUserPlan={currentUserPlan} isRedirectProp={isRedirect} /> : <></>}
    </div>
  );
};

export default AddToFavourite;
